/**
 * Пока что эти права используются только у Event-менеджера,
 * но в перспективе, возможно, где-то ещё их интегрируют,
 * добавят новые или исключат из спика имеющиеся,
 * потому прошу в отдельных модулях создавать свои константы с нужными
 * правами и наследоваться отсюда.
 *
 * Как это было сделано в @/modules/Personal/constants
 */

export const PERMISSIONS = {
  event_create: 'event.create',
  event_update: 'event.update',
  monitoring_manage: 'monitoring.manage',
  report_manage: 'report.manage',
  request_manage: 'request.manage',
  team_manage: 'team.manage',
  poll_view: 'poll.view',
  poll_check: 'poll.check',
  chat_manage: 'chat.manage',
  prize_manage: 'prize.manage',
  news_manage: 'news.create',
  constructor_update: 'constructor.save',
  exchange_manage: 'exchange.manage',
  template_create: 'template.create',
  template_update: 'template.update',
  expert_attach: 'expert.attach',
  expert_request: 'expert.request',
  expert_create: 'expert.create',
  vote_create: 'vote.create',
  vote_view: 'vote.view',
  member_transfer: 'member.transfer',
  permission_manage: 'permission.manage',
};

export const PERMISSIONS_NAMES = {
  [PERMISSIONS.event_create]: 'Создание мероприятий от имени организатора',
  [PERMISSIONS.event_update]: 'Обновление мероприятия',
  [PERMISSIONS.monitoring_manage]: 'Управление мониторингом',
  [PERMISSIONS.report_manage]: 'Управление экспортом участников',
  [PERMISSIONS.request_manage]: 'Управление заявками участников',
  [PERMISSIONS.team_manage]: 'Управление командами участников',
  [PERMISSIONS.poll_view]: 'Просмотр заданий для участников',
  [PERMISSIONS.poll_check]: 'Проверка заданий участников',
  [PERMISSIONS.chat_manage]: 'Управление чатами',
  [PERMISSIONS.prize_manage]: 'Управление призами',
  [PERMISSIONS.news_manage]: 'Создание новостей мероприятий',
  [PERMISSIONS.constructor_update]: 'Настройка конструктора мероприятий (передвигать блоки)',
  [PERMISSIONS.exchange_manage]: 'Назначение организаторов мероприятий',
  [PERMISSIONS.template_create]: 'Создание шаблонов мероприятий',
  [PERMISSIONS.template_update]: 'Обновление шаблонов мероприятий',
  [PERMISSIONS.expert_attach]: 'Прикрепление экспертов к мероприятию',
  [PERMISSIONS.expert_request]: 'Управление запросами экспертов',
  [PERMISSIONS.expert_create]: 'Создание экспертов',
  [PERMISSIONS.vote_create]: 'Создание голосований',
  [PERMISSIONS.vote_view]: 'Просмотр голосований',
  [PERMISSIONS.member_transfer]:  'Перемещение участников между этапами',
  [PERMISSIONS.permission_manage]: 'Настройка прав Event-менеджеров',
};

export const PERMISSIONS_DATA = Object.fromEntries(
  Object.values(PERMISSIONS).map((value) => ([
    value,
    {
      key: value,
      text: PERMISSIONS_NAMES[value],
    },
  ])),
);
